<template>
    <div class="invitaciones">
        <v-container class="my-1">
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-form
                            v-on:submit.prevent="validate()"
                            ref="form"
                            v-model="valid"
                    >
                        <v-card-title>
                            <span class="headline">{{$t('add_new_contact')}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <div class="flex">
                                    <v-text-field
                                            autofocus
                                            v-model="celular_nuevo"
                                            prepend-icon="phone_iphone"
                                            name="celular_nuevo"
                                            :label="$t('celular')"
                                            counter="10"
                                            maxlength="10"
                                            :rules="[rules.required, rules.counter, rules.number]"
                                    >
                                    </v-text-field>
                                </div>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog = false"
                            >{{$t('cerrar')}}</v-btn>
                            <v-btn
                                    color="primary"
                                    class="mr-4"
                                    @click="validate()"
                            >{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-layout calign-center >
                <v-flex>
                    <v-card class="elevation-5">
                        <v-toolbar class="mb-0" dark color="primary">
                            <v-toolbar-title>
                                {{$t('Invitacion')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-tabs
                                v-model="tab"
                                color="primary"
                                :centered="centered"
                                show-arrows
                                :grow="grow"
                                :vertical="vertical"
                                :right="right"
                                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                                :icons-and-text="icons"
                        >
                            <v-tabs-slider
                                    color="black"
                            ></v-tabs-slider>
                            <v-tab
                                    active-class="blue lighten-3"
                                    v-for="i in tabs"
                                    :key="i"
                                    :href="`#tab-${i}`"
                                    @click="fill_people"
                            >
                                <div v-if="i == 1">
                                    {{$t('ininvitación_normal')}}
                                    <v-icon v-if="icons">date_range</v-icon>
                                </div>
                                <div v-else>
                                    {{$t('invitacion_grupal')}}
                                    <v-icon v-if="icons">people</v-icon>
                                    <!--                                    <v-icon v-if="icons">update</v-icon>-->
                                </div>
                            </v-tab>

                            <v-tab-item
                                    :value="'tab-' + 1"
                            >
                                <v-flex>
                                    <v-card class="elevation-5">
                                        <v-card-text>
                                            <v-form class="mb-4" @submit.prevent="alta_invitacion()">
                                                <v-layout row wrap>
                                                    <v-flex xs1>

                                                        <v-btn
                                                                color="primary"
                                                                @click="dialog = true, celular_nuevo = ''"
                                                        >{{$t('add_new_contact')}} </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-card
                                                                color="blue-grey lighten-4"
                                                                dark
                                                        >
                                                            <v-card-text>
                                                                <v-autocomplete
                                                                        v-model="email"
                                                                        :items="items"
                                                                        multiple
                                                                        chips
                                                                        prepend-icon="email"
                                                                        :loading="isLoading"
                                                                        :search-input.sync="search"
                                                                        item-text="email"
                                                                        item-value="celular"
                                                                        :placeholder="$t('placeholder_invitados')"
                                                                        :label="$t('invitados')"
                                                                        :error-messages="errores.guests"
                                                                        :no-data-text="$t('no_resultados')"
                                                                >
                                                                    <template v-slot:selection="data">
                                                                        <v-chip
                                                                                :selected="data.selected"
                                                                                close
                                                                                class="chip--select-multi"
                                                                                @input="remove(data.item)"
                                                                        >
                                                                            <v-avatar>
                                                                                <img :src="data.item.avatar">
                                                                            </v-avatar>
                                                                            {{ data.item.email }} -
                                                                            {{ data.item.celular }}
                                                                        </v-chip>
                                                                    </template>
                                                                    <template v-slot:item="data">
                                                                        <template v-if="typeof data.item !== 'object'">
                                                                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                                                        </template>
                                                                        <template v-else>
                                                                            <v-list-tile-avatar>
                                                                                <img :src="data.item.avatar">
                                                                            </v-list-tile-avatar>
                                                                            <v-list-tile-content>
                                                                                <v-list-tile-title>{{ data.item.email }} - {{ data.item.celular }}</v-list-tile-title>
                                                                                <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                                                            </v-list-tile-content>
                                                                        </template>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete
                                                                v-model="areaId"
                                                                prepend-icon="location_city"
                                                                name="areaId"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                :label="$t('Area')"
                                                                :filter="customFilterArea"
                                                                :error-messages="errores.areaId"
                                                                :items="areas"
                                                                :no-data-text="$t('no_resultados')"
                                                                clearable
                                                        >
                                                            <template v-slot:selection="data">
                                                                <v-chip
                                                                        :selected="data.selected"
                                                                >
                                                                    <v-icon
                                                                            x-large
                                                                            :color="data.item.color"
                                                                    >
                                                                        label
                                                                    </v-icon>
                                                                    {{ data.item.nombre }}
                                                                </v-chip>
                                                            </template>
                                                            <template v-slot:item="data">
                                                                <v-icon
                                                                        x-large
                                                                        :color="data.item.color"
                                                                >
                                                                    label
                                                                </v-icon>
                                                                {{data.item.nombre}}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-menu
                                                                v-model="modal2"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                lazy
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="dateInv"
                                                                        :label="$t('fecha_inv')"
                                                                        prepend-icon="event"
                                                                        :error-messages="errores.dateInv"
                                                                        readonly
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                    v-model="dateInv"
                                                                    :min="get_current_date()"
                                                                    :locale="$t('region')"
                                                                    @input="modal2 = false"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                        <v-menu
                                                                ref="menu"
                                                                v-model="menu2"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                :return-value.sync="hora"
                                                                lazy
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="hora"
                                                                        :label="$t('hora_inv')"
                                                                        prepend-icon="access_time"
                                                                        :error-messages="errores.timeInv"
                                                                        readonly
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-time-picker
                                                                    v-if="menu2"
                                                                    v-model="hora"
                                                                    full-width
                                                                    @click:minute="$refs.menu.save(hora)"
                                                            ></v-time-picker>
                                                        </v-menu>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-textarea
                                                                v-model="subject"
                                                                prepend-icon="subject"
                                                                name="subject"
                                                                :placeholder="$t('placeholder_asunto')"
                                                                :label="$t('Asunto')"
                                                                :error-messages="errores.subject"
                                                        ></v-textarea>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-label>{{ $t('mensaje_equipo') }}</v-label>
                                                        <v-container fluid grid-list-sm>
                                                            <v-layout row wrap>
                                                                <v-flex v-for="(equipo, index) in sec_equip" :key="sec_equip[index].id" xs6>
                                                                    <v-checkbox
                                                                            v-model="equipo.selected"
                                                                            :label="equipo.nombre"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                                                        <v-radio-group
                                                                v-model="vehicle"
                                                                prepend-icon="directions_car"
                                                                name="vehicle"
                                                                :mandatory="false"
                                                                :error-messages="errores.vehicle"
                                                        >
                                                            <v-radio :label="$t('Si')" value=true></v-radio>
                                                            <v-radio label="No" value=false></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-textarea
                                                                v-model="notes"
                                                                prepend-icon="notes"
                                                                name="notes"
                                                                :placeholder="$t('placeholder_notas')"
                                                                :label="$t('Notas')"
                                                                :error-message="errores.notes"
                                                        ></v-textarea>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                v-model="companyFrom"
                                                                prepend-icon="business"
                                                                name="companyFrom"
                                                                :label="$t('Empresa')"
                                                                :error-messages="errores.companyFrom"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-alert
                                                        :value=alerta
                                                        type="warning"
                                                        outline
                                                        transition="scale-transition"
                                                >
                                                    Fallo con el Servidor
                                                </v-alert>
                                                <v-btn
                                                        :loading="loading"
                                                        color="primary"
                                                        type="submit">
                                                    {{$t('enviar')}}
                                                </v-btn>
                                            </v-form>

                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-tab-item>
                            <!--########################################## INVITACIÓN GRUPAL###############""""""""""""""""""""""""""""""""""""""-->
                            <v-tab-item
                                    :value="'tab-' + 2"
                            >
                                <v-flex>
                                    <v-card class="elevation-5">
                                        <v-card-text>
                                            <v-form class="mb-4" @submit.prevent="alta_invitacion_grupal()">
                                                <v-layout row wrap>
                                                    <v-flex xs12>
                                                        <v-autocomplete
                                                                v-model="email2"
                                                                :disabled="isUpdating"
                                                                :items="people"
                                                                box
                                                                chips
                                                                color="blue-grey lighten-2"
                                                                :label="$t('invitados')"
                                                                item-text="email_usuario"
                                                                item-value="email_usuario"
                                                                multiple
                                                                :loading="isUpdating"
                                                        >
                                                            <template v-slot:selection="data">
                                                                <v-chip
                                                                        :selected="data.selected"
                                                                        close
                                                                        class="chip--select-multi"
                                                                        @input="removePeople(data.item)"
                                                                >
                                                                    <v-avatar>
                                                                        <img :src="data.item.avatar_usuario">
                                                                    </v-avatar>
                                                                    {{ data.item.email_usuario }}
                                                                </v-chip>
                                                            </template>
                                                            <template v-slot:item="data">
                                                                <template v-if="typeof data.item !== 'object'">
                                                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                                                </template>
                                                                <template v-else>
                                                                    <v-list-tile-avatar>
                                                                        <img :src="data.item.avatar_usuario">
                                                                    </v-list-tile-avatar>
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title v-html="data.item.email_usuario"></v-list-tile-title>
                                                                        <v-list-tile-sub-title v-html="data.item.Grupo"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete
                                                                v-model="areaId2"
                                                                prepend-icon="location_city"
                                                                name="areaId2"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                :label="$t('Area')"
                                                                :filter="customFilterArea"
                                                                :error-messages="errores2.areaId"
                                                                :items="areas"
                                                                :no-data-text="$t('no_resultados')"
                                                                clearable
                                                        >
                                                            <template v-slot:selection="data">
                                                                <v-chip
                                                                        :selected="data.selected"
                                                                >
                                                                    <v-icon
                                                                            x-large
                                                                            :color="data.item.color"
                                                                    >
                                                                        label
                                                                    </v-icon>
                                                                    {{ data.item.nombre }}
                                                                </v-chip>
                                                            </template>
                                                            <template v-slot:item="data">
                                                                <v-icon
                                                                        x-large
                                                                        :color="data.item.color"
                                                                >
                                                                    label
                                                                </v-icon>
                                                                {{data.item.nombre}}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-menu
                                                                v-model="modal22"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                lazy
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="dateInv2"
                                                                        :label="$t('fecha_inv')"
                                                                        prepend-icon="event"
                                                                        :error-messages="errores2.dateInv"
                                                                        readonly
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                    v-model="dateInv2"
                                                                    :min="get_current_date()"
                                                                    :locale="$t('region')"
                                                                    @input="modal22 = false"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                        <v-menu
                                                                ref="menu2"
                                                                v-model="menu22"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                :return-value.sync="hora2"
                                                                lazy
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="hora2"
                                                                        :label="$t('hora_inv')"
                                                                        prepend-icon="access_time"
                                                                        :error-messages="errores2.timeInv"
                                                                        readonly
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-time-picker
                                                                    v-if="menu22"
                                                                    v-model="hora2"
                                                                    full-width
                                                                    @click:minute="$refs.menu2.save(hora2)"
                                                            ></v-time-picker>
                                                        </v-menu>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-textarea
                                                                v-model="subject2"
                                                                prepend-icon="subject"
                                                                name="subject2"
                                                                :placeholder="$t('placeholder_asunto')"
                                                                :label="$t('Asunto')"
                                                                :error-messages="errores2.subject"
                                                        ></v-textarea>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-label>{{ $t('mensaje_equipo') }}</v-label>
                                                        <v-container fluid grid-list-sm>
                                                            <v-layout row wrap>
                                                                <v-flex v-for="(equipo, index) in sec_equip" :key="sec_equip[index].id" xs6>
                                                                    <v-checkbox
                                                                            v-model="equipo.selected"
                                                                            :label="equipo.nombre"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                                                        <v-radio-group
                                                                v-model="vehicle2"
                                                                prepend-icon="directions_car"
                                                                name="vehicle2"
                                                                :mandatory="false"
                                                                :error-messages="errores2.vehicle"
                                                        >
                                                            <v-radio :label="$t('Si')" value=true></v-radio>
                                                            <v-radio label="No" value=false></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-textarea
                                                                v-model="notes2"
                                                                prepend-icon="notes"
                                                                name="notes2"
                                                                :placeholder="$t('placeholder_notas')"
                                                                :label="$t('Notas')"
                                                                :error-message="errores2.notes"
                                                        ></v-textarea>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                v-model="companyFrom2"
                                                                prepend-icon="business"
                                                                name="companyFrom2"
                                                                :label="$t('Empresa')"
                                                                :error-messages="errores2.companyFrom"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-alert
                                                        :value=alerta
                                                        type="warning"
                                                        outline
                                                        transition="scale-transition"
                                                >
                                                    Fallo con el Servidor
                                                </v-alert>
                                                <v-btn
                                                        :loading="loading"
                                                        color="primary"
                                                        type="submit">
                                                    {{$t('enviar')}}
                                                </v-btn>
                                            </v-form>

                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-tab-item>

                        </v-tabs>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { mapState, mapGetters } from 'vuex'
    Vue.use(VeeValidate)

    export default {
        name: "invitacion_tab_empleado",
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                //Controles TAB
                tab: null,
                icons: true,
                centered: true,
                grow: true,
                vertical: false,
                prevIcon: false,
                nextIcon: true,
                right: false,
                tabs: 2,
                //Controles TAB
                //Campos formulario
                alerta: false,
                update: false,
                id_update: 0,
                nombre: '',
                activa: '',
                id_empresa: '',
                areaId: '',
                errores: [],
                errores2: [],
                areas: [],
                calendario: false,
                hora: '',
                dateInv:'',
                vehicle: 'false',
                sec_equip: [],
                equipo: [],
                modal2: false,
                menu2: false,
                email: [],
                headers: [
                    {
                        text: 'Modificar',
                        align: 'left',
                        sortable: false,
                        value: 'update'
                    },
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: true,
                        value: 'id'
                    },
                    {
                        text: 'Nombre',
                        align: 'left',
                        sortable: true,
                        value: 'nombre'
                    },
                    {
                        text: 'Activa',
                        align: 'left',
                        sortable: true,
                        value: 'activa'
                    }
                ],
                casetas: [],
                subject: '',
                notes: '',
                companyFrom: '',
                cellNumber: '',
                id_empleado: '',
                loading: false,
                descriptionLimit: 60,
                entries: [],
                isLoading: false,
                search: null,
                guests: null,
                guests2: null,
                dialog: false,
                celular_nuevo: '',
                areaId2: '',
                modal22: false,
                dateInv2: '',
                menu22: false,
                hora2: '',
                subject2: '',
                vehicle2: 'false',
                notes2: '',
                companyFrom2: '',
                email2: [],
                people: [],
                grupos: [],
                contactosXgrupo:[],
                isUpdating: false,
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            fields () {
                if (!this.email) return []

                return Object.keys(this.email).map(key => {
                    return {
                        key,
                        value: this.email[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }

        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/users/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            if(this.entries.length > 0){
                                for(var i =0 ; i < response.data.length; i++){
                                    this.entries.push(response.data[i])
                                }
                            }
                            else
                                this.entries = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => (this.isLoading = false))
                }

            }
        },
        created: function(){
            this.get_areas()
            this.get_equipment()
            this.get_extra_data()
            this.get_grupos()
        },
        methods: {
            validate () {
                if (this.$refs.form.validate()) {
                    this.dialog = false
                    this.add_new_contact()
                }
            },
            get_grupos: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.grupos = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_contactosXgrupo: async function (id_grupo){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos/contacts_grupos/' + id_grupo,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.contactosXgrupo = response.data
                        // console.log(this.contactosXgrupo)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            delay() {
                return new Promise(resolve => setTimeout(resolve, 1000));
            },
            fill_people: async function (){
                this.people = []
                this.isUpdating = true
                // console.log('GRUPOS')
                // console.log(this.grupos)
                for(let group of this.grupos){
                    // console.log(i.id)
                    this.people.push(
                        {
                            "header": group.nombre
                        }
                    )
                    await this.get_contactosXgrupo(group.id)
                    await this.delay()
                    for(let contact of this.contactosXgrupo){
                        // console.log(contact.email_usuario)
                        this.people.push(
                            {
                                "celular_usuario": contact.celular_usuario,
                                "email_usuario": contact.email_usuario,
                                "Grupo": group.nombre,
                                "avatar_usuario": contact.avatar_usuario
                            }
                        )
                    }
                    this.people.push({ divider: true })
                }
                // console.log('PEOPLE')
                // console.log(this.people)
            },
            removePeople (item) {
                console.log(this.email2)
                const index = this.email2.indexOf(item.email_usuario)
                if (index >= 0) this.email2.splice(index, 1)
            },
            get_extra_data: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/empleados/user/' + this.getProfile.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.id_empleado = response.data[0].id
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_areas: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.areas = response.data
                        this.id_empresa = response.data[0].id_empresa
                        console.log(this.id_empresa)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            get_equipment: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.sec_equip = []
                        for(var i= 0; i < response.data.length; i++){
                            var algo = {
                                "id": response.data[i].id,
                                "nombre": response.data[i].nombre,
                                "selected": false
                            }
                            this.sec_equip.push(algo)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            add_new_contact(){
                this.entries.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
                this.email.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
            },
            get_guests(){
                this.guests= []

                for(var j = 0; j < this.email.length; j++){
                    for(var i = 0; i < this.entries.length; i++){
                        //Compara Número de Celular
                        if(this.entries[i].celular === this.email[j] && this.entries[i].email.length > 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j])
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": parseInt(this.entries[i].celular)
                                }
                            )
                            break
                        }
                        if(this.entries[i].celular === this.email[j] && this.entries[i].email.length === 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j])
                            this.guests.push(
                                {
                                    "email": null,
                                    "cellphone": parseInt(this.entries[i].celular)
                                }
                            )
                            break
                        }
                    }
                }
            },
            get_guests2(){
                this.guests2 = []

                for(var j = 0; j < this.email2.length; j++){
                    for(var i = 0; i < this.people.length; i++){
                        //Compara Número de Celular
                        if(this.people[i].email_usuario === this.email2[j]){
                            console.log(this.people[i].email_usuario, ' == ', this.email2[j])
                            console.log(this.people[i].celular_usuario)
                            this.guests2.push(
                                {
                                    "email": this.people[i].email_usuario,
                                    "cellphone": parseInt(this.people[i].celular_usuario)
                                }
                            )
                            break
                        }
                    }
                }
            },
            alta_invitacion: function () {
                // console.log('ENTRIES = ', this.entries)
                // console.log('EMAILS = ', this.email)
                this.get_guests()
                // console.log('GUESTS = ', this.guests)
                // for(var a = 0; a < this.guests.length ; a ++){
                //     console.log(this.guests[a].email)
                // }
                this.loading = true
                // console.log(this.sec_equip)
                var cadEquipo = ""
                for(var i = 0 ; i < this.sec_equip.length; i++){
                    if(this.sec_equip[i].selected == true){
                        cadEquipo += this.sec_equip[i].id.toString() + ","
                    }
                }
                console.log(cadEquipo)
                console.log(this.dateInv)
                console.log(this.hora)
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/create_inv/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                employeeId: this.id_empleado,
                                guests: this.guests,
                                cellNumber: this.cellNumber,
                                areaId: this.areaId,
                                dateInv: this.dateInv,
                                timeInv: this.hora,
                                subject: this.subject,
                                secEquip: cadEquipo,
                                vehicle: this.vehicle,
                                notes: this.notes,
                                companyFrom: this.companyFrom,
                                exp: null,
                                diary: '',
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.get_equipment()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                                this.loading = false
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                                this.loading = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            alta_invitacion_grupal: function () {
                // console.log('ENTRIES = ', this.entries)
                // console.log('EMAILS = ', this.email)
                this.get_guests2()
                // console.log('GUESTS = ', this.guests)
                // for(var a = 0; a < this.guests.length ; a ++){
                //     console.log(this.guests[a].email)
                // }
                this.loading = true
                // console.log(this.sec_equip)
                var cadEquipo = ""
                for(var i = 0 ; i < this.sec_equip.length; i++){
                    if(this.sec_equip[i].selected == true){
                        cadEquipo += this.sec_equip[i].id.toString() + ","
                    }
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/create_inv/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                employeeId: this.id_empleado,
                                guests: this.guests2,
                                cellNumber: this.cellNumber,
                                areaId: this.areaId2,
                                dateInv: this.dateInv2,
                                timeInv: this.hora2,
                                subject: this.subject2,
                                secEquip: cadEquipo,
                                vehicle: this.vehicle,
                                notes: this.notes2,
                                companyFrom: this.companyFrom2,
                                exp: null,
                                diary: '',
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.get_equipment()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                                this.loading = false
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores2 = error.response.data
                                this.loading = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.errores2 = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.clean_fields()
            },
            fill_fields(item){
                this.nombre = item.nombre
                this.activa = item.activa
            },
            clean_fields(){
                this.email = []
                this.cellNumber = ''
                this.areaId = ''
                this.dateInv= ''
                this.timeInv = ''
                this.subject = ''
                this.secEquip = ''
                this.vehicle = ''
                this.notes = ''
                this.companyFrom = ''
            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            remove: function(item) {
                const index = this.email.indexOf(item.celular)
                if (index >= 0) this.email.splice(index, 1)
            }
        }
    }
</script>

<style scoped>

</style>
